import { REQUIRED_MESSAGES } from '@srm/ui/lib/requiredMessage';
import InputNumberControl from '@srm/ui/controls/InputNumberControl';
import { ReactNode } from 'react';
import clsx from 'clsx';
import { IRatingScaleProps } from './IRatingScaleProps';
import Hint from '@srm/ui/hint';

interface IRatingScaleFrameProps extends IRatingScaleProps {
    /** Класс корня шкалы (`offer-crit-rating-scale-*`) */
    scaleClassName: string;
    /** Контрол балла — единственное, чем шкалы отличаются друг от друга */
    children: ReactNode;
}

/** Общая обвязка шкалы: подсказка, «балл × вес = рейтинг» */
export const RatingScaleFrame = ({
    className,
    isEdit,
    methods,
    hint,
    scaleClassName,
    children,
}: IRatingScaleFrameProps) => {
    return (
        <>
            {hint && isEdit && (
                <div className={'offer-crit-details__hint'}>
                    <Hint title={hint} tone="info" maxWidth="100%" />
                </div>
            )}
            <div className={clsx(scaleClassName, className)}>
                {children}
                <span className={'offer-crit-details__formula-text'}>×</span>
                <InputNumberControl
                    label="Вес"
                    name="weight"
                    required={true}
                    readOnly={true}
                    disabled={!isEdit}
                    floatPoints={4}
                    control={methods.control}
                    rules={{ required: REQUIRED_MESSAGES.number }}
                />
                <span className={'offer-crit-details__formula-text'}>=</span>
                <InputNumberControl
                    label="Рейтинг"
                    name="offerCrit.rating"
                    required={true}
                    readOnly={true}
                    disabled={!isEdit}
                    floatPoints={4}
                    control={methods.control}
                    rules={{ required: REQUIRED_MESSAGES.number }}
                />
            </div>
        </>
    );
};
